<template>
    <!-- 朗读开口秀 -->
    <div class="read-box">
        <div class="title">
            <img src="https://g.gsxcdn.com/2237465503_21uqvdr2.png" class="left" alt="">
            朗读开口秀
            <img src="https://g.gsxcdn.com/2237465715_nxtc8xeg.png" class="right" alt="">
        </div>
        <Myvideo
            ref="myvideo"
            :tag-index="3333333333"
            :page-data="pageData"
            :loop="false"
            play-img="https://i.gsxcdn.com/2274080577_ggn54um8.png"
            style="position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 1.33rem;
            border-radius: .21rem;
            width: 7.23rem;
            height: 4.05rem;"
            @gioreport="gioreport"
            @stop-other="stopOther"
            @videoended="handleVideoEnded"
        />
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import Myvideo from '@/components/Myvideo.vue';
import {sendMessageApp, isWXBrower} from '@/utils/utils';

@Options({
    components: {
        Myvideo
    },
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {
                    opusVideoMix: '',
                    courseCover: '',
                    opusUrl: '',
                    opusVideo: ''
                };
            }
        }
    }
})
export default class ReadAloud extends Vue {

    gioreport() {

    }

    // 点击播放视频时触发
    stopOther() {
        console.log('埋点上报播放视频', this.pageData.courseName);
    }

    // 视频播放完成时触发
    handleVideoEnded() {
        console.log('埋点上报视频播放完成', this.pageData.courseName);
    }
}
</script>

<style lang="scss" scoped>
.read-box {
    width: 8.51rem;
    height: 6.93rem;
    background: url('https://i.gsxcdn.com/2274079824_kb80tuf2.png') 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;

    .title {
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: .24rem;
        line-height: .56rem;

        .left {
            margin-right: .24rem;
            width: .96rem;
            height: .19rem;
        }

        .right {
            margin-left: .24rem;
            width: .96rem;
            height: .19rem;
        }
    }
}
</style>
